export const offersTR = {
    "shippingTitle": "ÜCRETSİZ KARGO",
    "shippingText1": "€ üzeri siparişlerde",
    "shippingText2": "ücretsiz kargo!",
    "cashTitle": "KAPIDA ÖDEME",
    "cashText": "Kapıda nakit ödeme ücretsiz!",
    "topSellers": "ÇOK SATANLAR"
}